import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b876595"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridHeader = _resolveComponent("GridHeader")!
  const _component_GridBody = _resolveComponent("GridBody")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "grid",
      style: _normalizeStyle({ height: _ctx.gridHeight, width: _ctx.gridWidth })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_GridHeader, { rowData: _ctx.headerData }, null, 8, ["rowData"]),
        _createVNode(_component_GridBody, {
          rowDatas: _ctx.rowDatas,
          isSubject: _ctx.activeComp.isSubject
        }, null, 8, ["rowDatas", "isSubject"])
      ])
    ], 4),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          showLBackDrop: true,
          showLoadingText: true,
          loadingText: "Loading..."
        }))
      : _createCommentVNode("", true),
    (_ctx.modalPRMisMatchAddress.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalPRMisMatchAddress.component), {
          key: 1,
          onHide: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalPRMisMatchAddress.show = false)),
          activeComp: _ctx.modalPRMisMatchAddress.activeComp,
          tabIndex: _ctx.modalPRMisMatchAddress.tabIndex
        }, null, 8, ["activeComp", "tabIndex"]))
      : _createCommentVNode("", true)
  ], 64))
}